import { render, staticRenderFns } from "./UserData.vue?vue&type=template&id=36af76d5&scoped=true&"
import script from "./UserData.vue?vue&type=script&lang=js&"
export * from "./UserData.vue?vue&type=script&lang=js&"
import style0 from "./UserData.vue?vue&type=style&index=0&id=36af76d5&prod&lang=scss&scoped=true&"
import style1 from "./UserData.vue?vue&type=style&index=1&id=36af76d5&prod&lang=scss&scoped=true&"
import style2 from "./UserData.vue?vue&type=style&index=2&id=36af76d5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36af76d5",
  null
  
)

export default component.exports